/** Convert screen coordinates into an SVG viewBox, rejecting points in preserveAspectRatio letterbox bands. */
export function svgViewBoxPoint(
  svg: SVGSVGElement,
  clientX: number,
  clientY: number,
  width: number,
  height: number,
): [number, number] | null {
  const matrix = svg.getScreenCTM();
  if (!matrix) return null;
  const point = new DOMPoint(clientX, clientY).matrixTransform(matrix.inverse());
  if (point.x < 0 || point.x > width || point.y < 0 || point.y > height) return null;
  return [point.x, point.y];
}

/** Keep a fixed virtual width while matching its height to the rendered viewport aspect ratio. */
export function aspectMatchedViewBoxHeight(viewportWidth: number, viewportHeight: number, viewBoxWidth: number, fallbackHeight: number): number {
  if (!Number.isFinite(viewportWidth) || !Number.isFinite(viewportHeight) || viewportWidth <= 0 || viewportHeight <= 0 || !Number.isFinite(viewBoxWidth) || viewBoxWidth <= 0) return fallbackHeight;
  return Math.max(1, Math.round(viewBoxWidth * viewportHeight / viewportWidth));
}
